export const ImportSouffranceDialogSteps = {
    WaitFile: 0,
    LoadFile: 1,
    SetSouffrances: 2,
    WaitImport: 3,
    ImportResult: 4
};
